export default {
    "iot-alert-data-mgmt.10001": "can not found the event record id = [{0}]",
}